import { render, staticRenderFns } from "./InfoBlock.vue?vue&type=template&id=a6b9ae94&"
import script from "./InfoBlock.ts?vue&type=script&lang=ts&"
export * from "./InfoBlock.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports